import { render, staticRenderFns } from "./SideRight_FAQ.vue?vue&type=template&id=54667588"
import script from "./SideRight_FAQ.vue?vue&type=script&lang=js"
export * from "./SideRight_FAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports